import { RPC_REQUEST_TIMEOUT } from '@exodus/web3-constants';
import { validate as validateDeps, validateCommonDeps, } from '@exodus/web3-rpc-handlers';
import { exposeHandlers } from './exposeHandlers.js';
import { validateRequest } from './validator.js';
export { default as createBtcDepsFactory } from './createBtcDeps.js';
const validateBtcDeps = (bitcoinDeps) => {
    const requiredKeys = [
        'getAccounts',
        'getActiveWalletAccountData',
        'broadcastTx',
        'transactionSigner',
        'messageSigner',
        'assetName',
        'logger',
    ];
    const optionalKeys = ['chainId', 'txSend'];
    validateDeps(bitcoinDeps, requiredKeys, optionalKeys);
};
export const registerRPCHandlers = ({ deps, RPC, transport, }) => {
    validateCommonDeps(deps, ['bitcoin']);
    validateBtcDeps(deps.bitcoin);
    if (!RPC) {
        throw new Error('"RPC" constructor parameter is required');
    }
    if (!transport) {
        throw new Error('"transport" parameter is required');
    }
    const { app, wallet } = deps;
    const rpc = new RPC({
        transport,
        parse: validateRequest,
        getIsDevelopmentMode: () => app.isDevelopmentEnvironment?.() ?? false,
        requestTimeout: RPC_REQUEST_TIMEOUT,
    });
    exposeHandlers(rpc, { ...app, ...deps.bitcoin, ...wallet });
    return rpc;
};
